import AddressAutocomplete from 'components/shared/AddressAutocomplete'

export default AddressAutocomplete
